if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('.product-json [type="application/json"]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      if(this.querySelector('.img.main')){
        this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      }
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.imageSlider = this.querySelector('[data-image-slider]')
      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          self.colorSwatches = self.querySelector('product-swatch.color-swatches');
          if (self.colorSwatches) {
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin',self.colorSwatches);
          }
        }, 10);
      }
    }

    onVariantChange(event) {
      var image = event.detail.variant.featured_image;
      var img = this.querySelector('.img.main');
      if(img){
        var width = Math.ceil(img.width / 100) * 100;
        if (img.classList.contains('lazyload')) {
          img.setAttribute('data-srcset', image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage);
        } else {
          this.currentImageUrl = image ? $s.imgUrlFilter(image.src, width+'x') : this.defaultImage;
          if (!this.imageObserver) {
            if (!img.classList.contains('lazyloaded')) {
              this.imageObserver = new MutationObserver(mutations => {
                if (img.classList.contains('lazyloaded')) {
                  this.imageObserver.disconnect();
                  this.imageObserver = null;
                  img.setAttribute('srcset', this.currentImageUrl);
                }
              });
              var config = { attributes: true, attributeFilter: ['class']};
              this.imageObserver.observe(img, config);
            } else {
              img.setAttribute('srcset', this.currentImageUrl);
            }
          }
        }
      }


    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('#main-product-'+this.dataset['section'])
      this.quantityElement = this.mainElement?.querySelector('.quantity-input');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');


      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }

      this.mainElement?.addEventListener('variantChange', (e)=>{
        var available = e.detail.variant && e.detail.variant.available;
        this.querySelector('.btn.add').style.display = !available ? 'none' : '';
        var btnUnavailable = this.querySelector('.btn-unavailable');
        if (available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add') ? this.querySelector('.btn.add').style.display = '' :'';
          this.querySelector('.sold-out-message') ? this.querySelector('.sold-out-message').style.display = 'none' : '';
          btnUnavailable ? btnUnavailable.style.display = 'none' : '';
          btnUnavailable ? btnUnavailable.style.opacity = '0' : '';
        } else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add') ? this.querySelector('.btn.add').style.display = 'none' : '';
          this.querySelector('.sold-out-message') ? this.querySelector('.sold-out-message').style.display = '' : '';
          var timeout =  btnUnavailable.classList.contains('init') ? 0 : 2000;
          btnUnavailable.setAttribute('disabled',true);
          btnUnavailable.style.opacity = '0.5'
          btnUnavailable.style.display = 'flex'

          if(timeout > 0){
            btnUnavailable.innerHTML = '<span>Loading...</span>'
          }
          setTimeout(() => {
            btnUnavailable.removeAttribute('disabled');
            !btnUnavailable.classList.contains('init') ? btnUnavailable.classList.add('init') : ''; 
            if(timeout > 0){
              btnUnavailable.innerHTML = '<span>Notify me when available...</span>'
            }

          }, timeout); 
        }
       
      });
    }

    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.mainElement?.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-description-short')) {
  class ProductDescriptionShort extends HTMLElement {
  	constructor() {
      super();
      this.anchor = this.querySelector('.read-more');
      
      this.anchor.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
          event.preventDefault();
          this.click()
        }
      });
      this.anchor.addEventListener('click', ()=>{
        this.scrollToElement()
      })
    }

    scrollToElement() {
      var headerOffset = 0;
      var selector = document.querySelector('.pdp-details');
      var newSelector = document.querySelector('product-tabs')
      var accordions = document.querySelectorAll('.product-tabs .tab-container');
      accordions.forEach((ac) => {          
        if (ac.classList.contains('details') ) {
          ac.classList.add('active');           
        } else {
          ac.classList.remove('active');
        }         
      })
      try {
        headerOffset = parseInt(getComputedStyle(document.body).getPropertyValue('--header-offset'))
      } catch (e) {
        console.warn(e);
      }
      
        newSelector = document.querySelector('product-tabs .product-tabs')
        var element = typeof(newSelector)=='string' ? document.querySelector(newSelector) : newSelector;
      
      window.scrollBy({
        left: 0,
        top: element.getBoundingClientRect().top - headerOffset - (20),
        behavior: ('smooth')
      })
    } 
  }
  customElements.define('product-description-short', ProductDescriptionShort);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('#main-product-'+this.dataset['section'])
      this.itemsWrapper = this.querySelector(':scope > div');
      this.productData = JSON.parse(this.mainElement?.querySelector('.product-json [type="application/json"]').textContent);
      this.desktopStyle = this.dataset.desktop;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement?.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.productData.options.findIndex(x=>x==key);
              if(optionIndex>=0) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          if(this.querySelector('[data-media-id="'+media.id+'"]')){
            this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
          }
        } else {
          if(this.querySelector('[data-media-id="'+media.id+'"]')){
            this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
          }
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
      if(document.querySelector('product-swatch[data-label="Size"] input:checked')) {
        var availableOptions = []
        var shadeName = ''
        
        this.productData.variants.forEach((element) =>{
          if(element.title.includes(document.querySelector('product-swatch[data-label="Size"] input:checked').value)){
            if(!availableOptions.includes(element.title)){
              availableOptions.push(element.title)
            }
          }
        })
      
        document.querySelectorAll('product-swatch[data-label="Shade"] input').forEach((shade)=>{
          shadeName = shade.value + ' / ' +   document.querySelector('product-swatch[data-label="Size"] input:checked').value;
          if(!availableOptions.includes(shadeName)){
            if(!shade.parentElement.classList.contains('hide')){
              shade.parentElement.classList.add('hide')
            }
          }else{
            if(shade.parentElement.classList.contains('hide')){
              shade.parentElement.classList.remove('hide')
            }
          }
        })
      }
      
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll(':scope > div'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        this.slider.moveToSlideRelative(index, true);
      }
    }
  }

  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.thumbsGallery = this.mainElement?.querySelector('product-thumbs');
      this.videoWrapper = this.querySelector('.video-wrapper');
      this.elThumb = this.querySelector('.thumbnail-wrapper');
      this.ytTagCreation();
      this.done = false;
      this.player;
      
      this.promise = new Promise((resolve, reject) => {
        let limitInterval = 20;
        let interval = setInterval(function() {
          if (window.YT && window.YT.loaded) {
            resolve('YT LOADED');      
            clearInterval(interval);
          }    
          if(!limitInterval){
            reject('YOUTUBE IFRAME NOT LOADED');    
            clearInterval(interval);
          }     
          limitInterval--
        }, 500);          
      });
      
      this.promise
        .then((data)=>{
          this.player = new YT.Player('player', {
            height: '390',
            width: '640',
            videoId: this.videoWrapper.dataset.mediaId,
            playerVars: {
              'playsinline': 1
            }
          });
          if (this.elThumb) {
            this.elThumb.addEventListener('click', (e) => {
              e.preventDefault();
              this.elThumb.classList.add('playing');
              if (this.player) {
                this.player.playVideo()
              }
            })
          }
        })
        .catch((data) => {
        })
        
      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                visibleItems.push(obj.querySelector('[data-file], video, iframe'));
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
      }
    }

    ytTagCreation() {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }      

    onPlayerReady(event) {
      event.target.playVideo();
    }

    onPlayerChange(event) {        
      if (event.data == YT.PlayerState.PLAYING && !this.done) {
          setTimeout(stopVideo, 6000);
          this.done = true;
          this.stopVideo()
      }
    }

    stopVideo() {
      if (this.player) {
        this.player.stopVideo();
         if(this.elThumb.classList.contains('playing')){
          this.elThumb.classList.remove("playing");
         }
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;

      // if(variant.price){
      //   document.querySelector('product-selling-plan').style.display = "none";
      // }else{
      //   document.querySelector('product-selling-plan').style.display = "block";
      // } 
      if(this.productData.media && variant) {
        this.filterMedia(variant)
        if(variant.featured_media) {
          this.showItem(variant.featured_media.id)
        }
      }
    }    

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
          
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 1) +'px)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }

        this.slider = new KeenSlider(this.itemsWrapper, {
          slideChanged: (keen) => {
            this.stopVideo();
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          mode: "snap",
          loop: !this.closest('.main-product-grid-gallery') ? true : false,
          wheel: false,
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement?.querySelector('product-gallery');
      this.thumbs = this.querySelectorAll('.thumb-wrap');
      this.navBar = this.dataset.navbarMobile ? true : false;
      this.slidesDesktop = this.dataset.slidesDesktop ? this.dataset.slidesDesktop : false;
      this.slidesMobile = this.dataset.slidesMobile ? this.dataset.slidesMobile : false;

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });


      if (this.thumbs.length > 0) this.selectThumb(0)

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        this.thumbs.forEach( (el,i) => {
          if(e.detail.currentSlide().dataset.mediaId == el.dataset.mediaId){
            this.selectThumb(i)
            this.showItem(el.dataset.mediaId);
          }
        });
  
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      
      if(this.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && this.desktopStyle=='carousel' )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll(':scope > div').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(min-width: 901px)'] = {
          slidesPerView: this.slidesDesktop ? this.slidesDesktop : 5,
          spacing: 10
        }
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: this.slidesDesktop ? this.slidesDesktop : 5,
          spacing: 10
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: this.slidesMobile ? this.slidesMobile : 5,
          spacing: 5,
          //vertical: false
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          vertical: true,
          mode: "snap",
          loop: !this.closest('.main-product-grid-gallery') ? true : false,
          navBar: this.querySelector('.keen-navbar'),
          slidesPerView: this.slidesDesktop ? this.slidesDesktop : 5,
          spacing: 10,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints
        });
      }
    }

    selectThumb(p) {
      this.thumbs.forEach(e => e.classList.remove('selected'));
      if (this.thumbs[p]) this.thumbs[p].classList.add('selected');
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-variants-display')) {
  class ProductVariantsDisplay extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('[id^="main-product-template"]');
      this.updateVariant();
    }

    updateVariant() {
      var mainElement = this.mainElement;
      mainElement.addEventListener('variantChange', (e)=>{
        var variant = e.detail.variant;
        this.innerHTML = variant.option1;
      });
    }

  }
  customElements.define('product-variants-display', ProductVariantsDisplay);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = document.querySelector('#main-product-'+this.dataset['section']);
      if(this.mainElement?.querySelector('product-variants')){
        this.variantsElement = this.mainElement?.querySelector('product-variants') ;
      }
      this.quantityElement = this.mainElement?.querySelector('.quantity-input');
      this.dealElement = this.querySelector('.deal')
      this.retailElement = this.querySelector('.retail');
      this.priceByQuantity = this.dataset.priceByQuantity=='true';
      this.priceBySubscription = this.dataset.priceBySubscription=='true';
      var eventsList = ['variantChange'];
      if (this.priceByQuantity) {
        eventsList.push('quantityChange');
      }
      if (this.priceBySubscription) {
        eventsList.push('sellingPlanChange');
      }

      eventsList.forEach((event)=>{
        this.mainElement?.addEventListener(event, (e)=>{
          var data = e.detail.variant || e.detail.sellingPlan;
          var quantity = this.priceByQuantity ? this.getQuantity() : 1;
    
          if(!data) {
            data = this.getCurrentVariant();
          }
        	if(data) {
        		this.dealElement.innerHTML = $s.formatMoney(data.price * quantity, 'amount_no_decimals');

            if(data.compare_at_price > data.price) {
              this.retailElement.classList.remove('hide');
              this.retailElement.innerHTML = $s.formatMoney(data.compare_at_price * quantity, 'amount_no_decimals');
            } else {
              this.retailElement.classList.add('hide');
              this.retailElement.innerHTML = '';
            }


        	} else {
        		this.dealElement.innerHTML = '';
            this.retailElement.innerHTML = '';
        	}
        });
      });
    }

    getCurrentVariant() {
      if(this.variantsElement){
        return this.variantsElement.getCurrentVariant();
      }
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }

  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('#main-product-'+this.dataset['section'])

      this.productData = JSON.parse(this.mainElement?.querySelector('.product-json [type="application/json"]').textContent);
      this.variantInput = this.querySelector('[data-variant-id]');

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant());
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() { 
      return this.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant) {
      let selector = document.querySelectorAll('#option-selector');
      if(selector){
        document.querySelectorAll('#option-selector option').forEach((option => {
          if(variant.title.includes(option.innerHTML)){
            document.getElementById('option-selector').value = option.value;
            document.getElementById('option-selector').dispatchEvent(new Event('change'));
          }
         }))
      }

      let currentID = document.querySelector('.current-id');

      if(currentID){
        currentID.innerHTML = variant.id
      }

      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement?.dispatchEvent(new CustomEvent('variantChange', {detail: {variant}}));
    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.productData.variants;
      this.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.querySelectorAll('[data-option]').forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.querySelectorAll('[data-option]').forEach((element, index)=>{
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color","Shade"]
      this.mainElement = this.closest('.product-main-element');
      this.productData = JSON.parse(this.mainElement?.querySelector('.product-json [type="application/json"]').textContent);
      this.variantsElement = this.closest('product-variants') || this.mainElement?.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.groupSwatches = this.dataset.groupSwatches === 'true';
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement?.dataset.section}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement?.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.variantsElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement?.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
  		var html = `
        <div class="option-name small-label">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">Select ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'a '+this.label+':' : this.label}</span>
          ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? '<span aria-hidden="true" class="option-value">'+defaultValue+'</span>' : ''}
          
          ${this.infoLink}
        </div>
        ${this.groupSwatches && optionValues.length > 2 ? 
          `<div class="flex align-items-center justify-content-start">
            <div class="swatch-group flex flex-wrap group-swatches"></div>
            <div class="expand-group-swatches">+${optionValues.length - 2} <span class="medium-down--hide">More</span></div>
          </div>` : 
          `<div class="swatch-group flex flex-wrap"></div>`
        }
  		`;
  		this.innerHTML = html;
      
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
  		options.filter(o => o.value).forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement?.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        var variantID = this.variantsElement.productData.variants.find(x=>x.options[this.optionNumber-1]==option.value).id;
  			html += `
          <div class="swatch" data-exclusive-variant="${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'exclusive-'+optionValueHandle : ''}" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement?.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
  				  <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ">
                <div data-variant-id="${variantID}" class="color-wrapper ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? ' active color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}"></div>
              	<span>${option.value.toLowerCase().includes('refill') ? this.refillText(option.value)+soldOut : this.normalText(option.value)+soldOut}</span>
              </div>
              <div class="hide exclusive-badge"></div>
            </label>
          </div>
  			`;
  		});
  		
      var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;
      
  		if(defaultValue && group.querySelector('input[value="'+defaultValue+'"]')) {
        group.querySelector('input[value="'+defaultValue+'"]').checked = true;
  		} else {
        group.querySelector('input').checked = true;
  		}
    }

    refillText(a){
      var info = a.toLowerCase().replace('refill', '').trim()
      info = info.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      info = info.replace('(', '<small>(')
      info = info.replace(')', ')</small>')
      info = info + '<span class="label">Refill</span>'
      return info
    };
    normalText(a){
      var info = a.toLowerCase().trim()
      info = info.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      info = info.replace('(', '<small>(')
      info = info.replace(')', ')</small>')
      return info
    };
    
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.variantsElement = this.closest('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      if (this.label != 'Ounces') {
        this.buildOptionSelector();
      }
      
    }

    buildOptionSelector() {
      var currentVariant = this.variantsElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = this.parentElement.dataset.section+'-option-'+this.optionNumber;
    	var optionElement = document.createElement('div');
  		var html = `
  			<label class="option-name" for="${optionId}">${this.label}</label>
  			<select id="${optionId}"></select>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
      var select = this.querySelector('select');
    	var html = '';
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? ' - Sold Out' : '');        
          html += `<option value="${option.value}">${option.value}${soldOut}</option>`;
  		});
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}


//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('#main-product-'+this.dataset['section'])
      this.productData = JSON.parse(this.mainElement?.querySelector('.product-json [type="application/json"]').textContent);
      this.variantsElement = this.mainElement?.querySelector('product-variants');
      this.quantityElement = this.mainElement?.querySelector('.quantity-input');
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime || "One-time purchase";
      this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
      this.textSubscribeSave = this.dataset.textSubscribesave || "Subscribe \u0026 Save";
      this.input.addEventListener('change', ()=>{
        this.mainElement?.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });

      ['variantChange','quantityChange'].forEach((event)=>{
        this.mainElement?.addEventListener(event, (e)=>{
          var self = this;
          this.groupsContainer.innerHTML = this.getGroupsHtml();
          this.plansContainer = this.querySelector('[data-plans]');  //obtained newly generated element
          var subscribeCheckbox = this.querySelector('[name="subscribe_save"]');
          this.groupsContainer.querySelectorAll('.check-container').forEach((element)=>{
            element.addEventListener("keypress", function(event) {
              if (event.key === "Enter") {
                event.preventDefault();
                this.click();
              }
            });
          })

          if (subscribeCheckbox) {
            subscribeCheckbox.addEventListener('change', function() {
              var radioButton = null;

              if (this.checked) {
                radioButton = self.groupsContainer.querySelector('[name="purchase_option"].subscription');
              } else {
                radioButton = self.groupsContainer.querySelector('[name="purchase_option"].one-time');
              }

              radioButton.checked = true;
              radioButton.dispatchEvent(new Event('change', {bubbles: true}));
            });
          }         
          if(this.plansContainer){
          this.groupsContainer.querySelectorAll('[name="purchase_option"]').forEach((groupInput, i)=>{

            groupInput.addEventListener('change', ()=>{
             
                var frequencyOption = this.plansContainer.querySelector('.radio-suscribe-options:checked');

                //get html with same plan name currently selected
                this.plansContainer.innerHTML = this.getPlansHtml(frequencyOption?frequencyOption.dataset.plan : '');
                
                var frequencyWrapper = this.querySelector('.frequency-wrapper');
                if(frequencyWrapper){
                  frequencyWrapper.addEventListener('change',(el)=>{
                    var id = frequencyWrapper.value;
                    document.getElementById(`${id}`).click();
                  })
                }
                this.querySelectorAll('.check-container input').forEach(function(e){
                  e.addEventListener('click',(el)=>{
                    if(el.srcElement.name == 'subscribe_save' && document.querySelector('.suscribe-options.enabled') == null){
                      document.querySelector('input[name="purchase_option"]').click()
                    }
                  })
                })
  
                this.querySelectorAll('.btn-suscribe').forEach(function(e){
                  e.addEventListener("keypress", function(event) {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      this.click();
                    }
                  });
                })
                //only get the select if enabled, otherwise clear selling_plan input value
                var options = this.plansContainer.querySelectorAll('.suscribe-options.enabled input');
                if(options.length > 0) {
                  options.forEach((option, i) => {
                    option.addEventListener('change', ()=>{
                      var selection = this.querySelector('.frequency-wrapper').value.replace("suscribe_","")
                      this.productData.sellingPlanGroups.forEach((plany)=>{
                        if(plany.selling_plans[0].id == selection){
                          this.querySelectorAll('input[class="subscription"]').forEach((inputSub)=>{
                            inputSub.value = plany.id
                          })
                          this.updateSellingPlan(selection);
                        }
                      })
                    });
                  });
  
                  var optionToCheck = this.plansContainer.querySelector('input[value="'+this.input.value+'"]');
                  if (!optionToCheck) {
                    optionToCheck = options[0];
                  }
                  optionToCheck.checked = true;
                  optionToCheck.dispatchEvent(new Event('change', {bubbles: true}));
  
                } else {
                  this.updateSellingPlan("");
                } 
              

            });
          });

          var currentPlan = this.getCurrentPlan();

          if(currentPlan) {
            var groupInput = this.groupsContainer.querySelector('[value="'+currentPlan.selling_plan_group_id+'"]');
          } else {
            var groupInput = this.groupsContainer.querySelector('[name="purchase_option"]');
          }

          groupInput.checked = true;
          groupInput.dispatchEvent(new Event('change', {bubbles: true}));
        }else{
          var groupInput = this.groupsContainer.querySelector('[name="purchase_option"]');
          groupInput.dispatchEvent(new Event('change', {bubbles: true}));
          this.updateSellingPlan("");
          this.querySelector('.one-time').click();
        }
        });
      });
    }    
    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      var subscribeCheckbox = this.querySelector('[name="subscribe_save"]');
      if (sellingPlanId) {
       // this.inputFrequencyName.value = this.getCurrentGroup().selling_plans.options[0].value;
        if (subscribeCheckbox) {
          subscribeCheckbox.checked = true;
        }
      } else {
        this.inputFrequencyName.value = ''
        if (subscribeCheckbox) {
          subscribeCheckbox.checked = false;
        }
      }
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    getGroupsHtml() {
      var currentVariant = this.getCurrentVariant();
      var html = '';
      var quantityToUse = 1; //this.getQuantity(); //REF: Price By Quantity
      var section = document.querySelector('product-price').dataset.section;
      var price = $s.formatMoney(currentVariant.price * quantityToUse, 'amount_no_decimals').replace('.00', '');
      let priceAdjustment = this.productData.sellingPlanGroups[0].selling_plans[0].price_adjustments;
      let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); // expected percentage
      var adjustedPrice = currentVariant.price - ((currentVariant.price/100)*discount);
      var finalPrice = $s.formatMoney(adjustedPrice * quantityToUse, 'amount_no_decimals').replace('.00', '')

      if(currentVariant.selling_plan_allocations.length > 0){
      html += `<div class="input-sub-wrapper subscription">`;
      html += `<label class="check-container" tabindex="0">
                <div>
                <input type="checkbox" name="subscribe_save" `+(this.productData.requiresSellingPlan ? 'disabled="disabled"' : '')+` >` + (discount ? this.textSubscribeSave + ' <span class="option-discount"></span>' : this.textSubscribe + ' with free shipping') + `</span>
                <span class="checkmark"></span>
                </div>
                <div>
                <span class="retail final-amount">${price}</span>
                <span class="final-amount">${finalPrice}</span>
                </div>
            </label>
            <div data-plans></div>               
            `;
            
      html += `</div>`;
    }
      if(!this.productData.requiresSellingPlan) {
        let optionId = `plan-option-onetime-${this.dataset['section']}`;
        let optionPrice = $s.formatMoney(currentVariant.price * quantityToUse, 'amount_no_decimals').replace('.00', '');
        html += `<div class="input-sub-wrapper onetime">`;
        html += 
        `<label class="check-container" tabindex="0">
        <div>
          <input type="checkbox" name="purchase_option" class="one-time" value="" id="${optionId}">
          <label for="${optionId}">${this.textOnetime} <span class="option-price"> - ${optionPrice}</span></label>
          <span class="checkmark"></span>
          </div>
          <div>
          <span class="final-amount">${price}</span>
          </div>
        </label>

        `;
        html += `</div>`;
      }
  
      if(currentVariant) {
        this.productData.sellingPlanGroups.forEach((group)=>{
          let priceAdjustment = group.selling_plans[0].price_adjustments;
          let discount = (priceAdjustment && priceAdjustment.length > 0 ? priceAdjustment[0].value : 0); // expected percentage
          let planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_group_id==group.id);
          var quantityToUse = 1; //this.getQuantity(); //REF: Price By Quantity
          if(planAlloc) {
            let optionId = `plan-option-${group.id}-${this.mainElement?.sectionId}`;
            let optionPrice = $s.formatMoney(planAlloc.price * quantityToUse, 'amount_no_decimals').replace('.00', '');
            html += `
              <div>
                <div class="hide">
                  <input type="radio" name="purchase_option" class="subscription" value="${group.id}" id="${optionId}">
                  <label for="${optionId}">` + (discount ? this.textSubscribeSave + ' <span class="option-discount">'+discount+'%</span>' : this.textSubscribe) + ` <span class="option-price"> - ${optionPrice}</span></label>
                </div>  
              </div>
            `;
          }
        });
      
      }
      return html;
    }

    getPlansHtml(selectedName) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.getCurrentVariant();
      var enabled = true;
      var currentGroup = this.getCurrentGroup();
      if (!currentGroup) {
        
        enabled = false;
      }
      var html = '';
      var groups = this.productData.sellingPlanGroups;

      if(currentGroup) {
        var isOneOption = currentVariant.selling_plan_allocations.length==1;
        selectedName = selectedName.trim();
        html = '<div class="suscribe-options ' + (enabled ? 'enabled' : '') + (isOneOption ? ' hide' : '') +'">';
        
        currentVariant.selling_plan_allocations.forEach((plan, i)=>{
          var sellingPlan = groups[i].selling_plans.find(x=>x.id==plan.selling_plan_id);
          if(sellingPlan){
            html += `<input id="suscribe_${sellingPlan.id}" name="suscribe_choose" type="radio" data-plan="${sellingPlan.name.trim()}" class="visually-hidden radio-suscribe-options" value="${sellingPlan.id}" `+ (selectedName==sellingPlan.name.trim() || i==0 && !selectedName ? 'checked="true"' : '') +`>
            <label class="btn btn-suscribe visually-hidden" tabindex="0" for="suscribe_${sellingPlan.id}">${sellingPlan.name.replace('Delivery every ', '')}</label>`;       
            }
        });
                
        html += `<select class="frequency-wrapper">`
        currentVariant.selling_plan_allocations.forEach((plan, i)=>{
          var sellingPlan = groups[i].selling_plans.find(x=>x.id==plan.selling_plan_id);
          if(sellingPlan){
            html += `<option class="btn btn-suscribe" tabindex="0" value="suscribe_${sellingPlan.id}">Delivery every ${sellingPlan.name.replace('Delivery every ', '')}</option>`;       
          }
        });
        html += `</select>`
        
        
  
        var firstPoint = `$Save up to 15% (5% on your first order, 10% on your second, 15% on every order after)`;
        firstPoint = firstPoint.replace("$","")
        var secondPoint = `$Free Shipping for US Orders`;
        secondPoint = secondPoint.replace("$","")
        html += `<div class="wrapper-info">
              <div class="point">${firstPoint}</div>
              <div class="point">${secondPoint}</div>
            </div>`
        html += `</div>`;
        if (isOneOption) {
          html += `<div class="selling-plan-name">${currentGroup.selling_plans[0].name}</div>`;
        }
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.getCurrentVariant();
      
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

    getCurrentGroup() {
      var groupId = this.querySelector('[name="purchase_option"]:checked').value;
      var grupoActual = this.productData.sellingPlanGroups.find(x=>x.id==groupId);
      this.productData.sellingPlanGroups.forEach((groupo)=>{
       if(groupo.id == groupId){
        this.querySelector('input[name="selling_plan_frequency"]').value = groupo.options[0].values[0]
        grupoActual = groupo
       }
      })
      return grupoActual;
    }
  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}


(function showGcInputs(){
  let checkbox = document.querySelector('#sendToSelf')
  let inputWrapper = document.querySelector('#gc-input-wrapper')
  if(checkbox){
    checkbox.parentNode.style.display = 'block'
    checkbox.addEventListener('change', function(e){
      e.preventDefault();
      if(inputWrapper){
        inputWrapper.style.display = e.target.checked ? 'block' : 'none'   
      }
    })
  }
  const recipientName = document.querySelector('#recipientName')
  const recipientPhone = document.querySelector('#recipientPhone')
  const recipientEmail = document.querySelector('#recipientEmail')
  const senderName = document.querySelector('#senderName')  
  
  let theInput = []
  if(recipientPhone){
    recipientPhone.addEventListener('blur', function(){
      theInput = recipientPhone.value.trim().split(' ')
      if (theInput[0]) {
        if(/^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/gm.test(theInput[0]) && theInput.length === 1){
        recipientPhone.name = "properties[_gcp_recipient_phone]"
        recipientPhone.parentNode.querySelector('span').style.display = 'none'
        recipientPhone.value = recipientPhone.value.trim()
        } else {
          recipientPhone.name = ''
          recipientPhone.parentNode.querySelector('span').style.display = 'block'
        }
      }
    })
  
    recipientPhone.addEventListener('focus', function(){
      recipientPhone.parentNode.querySelector('span').style.display = 'none'
    })
  }


  document.querySelector('form product-buttons > button:nth-child(1)').addEventListener('click', function(){
    validateInput(recipientName)
    validateInput(recipientEmail)
    validateInput(senderName) 
  })

  let validateInput = function(input){
    input.addEventListener('invalid', (function(){
      return function(e) {
        e.preventDefault();
        input.parentNode.querySelector('span').style.display = 'block'
      };
    })());
    input.addEventListener('blur', function(){
      if (input.type === 'text') {
        if (input.id === 'recipientEmail') {
          if (input.value){
            if (/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g.test(input.value)) {
              input.parentNode.querySelector('span').style.display = 'none'
            } else {
              input.parentNode.querySelector('span').textContent = 'Enter a valid email'
              input.parentNode.querySelector('span').style.display = 'block'
            }
          } else {
            input.parentNode.querySelector('span').textContent = 'Please complete this field'
            input.parentNode.querySelector('span').style.display = 'block'
          }  
        } else {
          input.parentNode.querySelector('span').style.display =  input.value ? 'none' : 'block'
        }        
      }
    });
  }
})()

function toggleDatePicker(button){
  var datePicker = document.getElementById("gcp_delivery_date");
  if(button.value === "Send Now"){
    datePicker.style.display = "none";
  } else if(button.value === "Send Later"){
    datePicker.style.display = "block";
  } 
}
